export default {
  title: 'Importuj menu',
  master_title: 'Tryb marki - Import menu',
  buttons: {
    import: 'Importuj',
  },
  toasts: {
    import: {
      pending: '⏳Import może trwać dłużej — wykonujemy go w tle. Sprawdź menu restauracji za kilka minut.',
    },
  },
};
